module.exports = __webpack_public_path__ + "static/img/MSOBCFD-logo.d125d1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MSOBCFD-logo.jpg
// module id = oIz2
// module chunks = 4